/**
 * Calls to the streams APIs go through this app's own nginx (/api/...), which
 * validates the access-control session token and adds the API keys and the
 * streams credentials server-side, so none of them are part of the bundle.
 */
export const API_STREAMS = "/api/streams";
export const API_STREAMS_ADMIN = "/api/streams-admin";

export const sessionToken = () => {
  try {
    return JSON.parse(sessionStorage.getItem("userData"))?.token || "";
  } catch {
    return "";
  }
};

export const apiHeaders = () => ({ "x-access-token": sessionToken() });

// Query string values typed by users (stream paths, well names)
export const q = (value) => encodeURIComponent(value ?? "");
